import React from 'react';
import { Box, styled, Drawer, Toolbar, useTheme } from '@mui/material';
import Navbar from './Navbar';
import SideMenuContent, { drawerWidth } from './SideMenu';
import { useSidebar } from '../../context/SidebarContext';
import { useAuth } from '../../context/AuthContext';
import { Outlet } from 'react-router-dom';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    // Mobile responsiveness
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
  }),
);

const MainLayout = () => {
  const { isOpen } = useSidebar();
  const { token } = useAuth();
  const theme = useTheme();

  if (!token) {
    return <Outlet />;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Navbar />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
          // Mobile responsiveness
          [theme.breakpoints.down('md')]: {
            '& .MuiDrawer-paper': {
              width: '100%',
              maxWidth: drawerWidth,
            },
          },
        }}
        variant="persistent"
        anchor="left"
        open={isOpen}
      >
        <SideMenuContent />
      </Drawer>
      <Main open={isOpen}>
        <Toolbar />
        <Box p={{ xs: 2, sm: 3 }}>
          <Outlet />
        </Box>
      </Main>
    </Box>
  );
};

export default MainLayout; 